import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';

@Component({
  selector: 'app-opt-input',
  templateUrl: './opt-input.component.html',
  styleUrls: ['./opt-input.component.scss'],
})
export class OptInputComponent implements AfterViewInit {
  @Input('readonly') readonly: boolean = false;
  @Input('length') length: number = 4;
  @Output('currentValue') currentValue: EventEmitter<string | false> =
    new EventEmitter<string | false>();
  valArray = ['', '', '', ''];
  constructor() {}

  ngAfterViewInit(): void {
    this.setFocus();
  }
clearOTPFieldsAndFocus(){ 
this.valArray=['', '', '', ''];
setTimeout(() => {
  const otpInput0 = document.getElementById("cet-otp-0") as HTMLInputElement;
  const otpInput1 = document.getElementById("cet-otp-1") as HTMLInputElement;
  const otpInput2 = document.getElementById("cet-otp-2") as HTMLInputElement;
  const otpInput3 = document.getElementById("cet-otp-3") as HTMLInputElement;

  otpInput0.value = "";
  otpInput1.value = "";
  otpInput2.value = "";
  otpInput3.value = "";

  otpInput0.focus();
});
  }
  onPaste(index: number, event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let val = clipboardData?.getData('text') || '';
    val = val.slice(0, this.length - index);
    for (let i = 0; i < val.length; i++) {
      this.emitOrNext(index + i, val[i]);
    }
  }

  onInput(index: number, event: Event) {
    let val = (event as InputEvent).data || '';
    val = val.slice(0, 1);
    val = val.replace(/[^\d]+/g, '');
    this.emitOrNext(index, val);
  }

  emitOrNext(index: number, val: string) {
    (document.getElementById('cet-otp-' + index) as HTMLInputElement).value =
      val;
    this.valArray[index] = val;
    if (val) {
      let next = document.getElementById('cet-otp-' + (index + 1));

      if (index == this.length - 1) {
        document.getElementById('cet-otp-' + index)?.blur();
      } else next?.focus();
    }
    this.emitCurrentValue();
  }

  emitOrPrev(index: number) {
    if (index == 0) {
      this.valArray[0] = '';
    } else {
      let prev = document.getElementById('cet-otp-' + (index - 1));
      // this.passcode[index] = '';
      prev?.focus();
    }
    this.emitCurrentValue();
  }

  emitCurrentValue() {
    let val = this.valArray.join('');
    if (val.trim().length == this.length) {
      return this.currentValue.emit(val);
    }
    return this.currentValue.emit(false);
  }

  setFocus(){
    document.getElementById('cet-otp-0')?.focus();
  }
}
